const initOnSwymLoad = () => {
  console.log("Swym scripts tags are installed on your store");

  let swymInjectedButton = document.querySelector('.swym-button-bar');
  if (swymInjectedButton) {
    swymInjectedButton.style.display = 'none';
  }
};

// Create a promise that resolves when SWYM has loaded
const swatPromise = new Promise((resolve) => {
  function onSwymLoadCallback(swat) {
    if (swat) {
      initOnSwymLoad();
      resolve(swat);
    }
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(onSwymLoadCallback);
});

// Function to fetch wishlist items
export const fetchWishlistItems = async () => {
  const swat = await swatPromise; // Wait for the promise to resolve

  return new Promise((resolve, reject) => {
    const onSuccess = (lists) => {
      resolve(lists);
    };

    const onError = (error) => {
      console.log("Error while fetching all Lists", error);
      reject(error);
    };

    swat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError,
    });
  });
};

// Function to fetch wishlist details based on lid
export const fetchWishlistDetails = async (lid) => {
  const swat = await swatPromise; // Wait for the promise to resolve

  const listConfig = {
    lid
  };

  return new Promise((resolve, reject) => {
    const onSuccess = (listDetails) => {
      resolve(listDetails);
    };

    const onError = (error) => {
      console.log("Error while fetching list details", error);
      reject(error);
    };

    swat.fetchListDetails(listConfig, onSuccess, onError);
  });
};

// Function to create new wishlist
export const createNewWishlist = async (listName) => {
  const swat = await swatPromise; // Wait for the promise to resolve

  const listConfig = {
    lname: listName
  };

  return new Promise((resolve, reject) => {
    const onSuccess = (newList) => {
      resolve(newList);
    };

    const onError = (error) => {
      console.log("Error while creating new list", error);
      reject(error);
    };

    swat.createList(listConfig, onSuccess, onError);
  });
};

export const markListAsPublic = async (lid) => {
  const swat = await swatPromise; // Wait for the promise to resolve

  return new Promise((resolve, reject) => {
    const onSuccess = (response) => {
      console.log("Successfully marked list public ");
      resolve(response);
    };

    const onError = (error) => {
      console.log("Error while marking list as public", error);
      reject(error);
    };

    swat.markListPublic(lid, onSuccess, onError);
  });
};

// Function to add product to wishlist
export const addToWishlist = async (listId, product, variantDetails) => {
  const swat = await swatPromise; // Wait for the promise to resolve

  const productObj = {
    du: `${window.location.origin}/products/${product?.handle}`,
    empi: product?.id,
    epi: variantDetails?.selectedVariant?.id || null,
    cprops: {
      variantDetails,
      productDetails: product
    }
  }
  
  return new Promise((resolve, reject) => {
    const onSuccess = (addedListItem) => {
      resolve(addedListItem);
    };

    const onError = (error) => {
      console.log("Error while adding the Product to the List", error);
      reject(error);
    };

    swat.addToList(listId, productObj, onSuccess, onError);
  });
};

// Function to add product to multiple wishlist
export const addProductToMultipleWishlist = async (lists, product, variantDetails) => {
  const swat = await swatPromise; // Wait for the promise to resolve

  const productObj = {
    du: `${window.location.origin}/products/${product?.handle}`,
    empi: product?.id,
    epi: variantDetails?.selectedVariant?.id || null,
    cprops: {
      variantDetails,
      productDetails: product
    }
  }
  
  return new Promise((resolve, reject) => {
    const onSuccess = (response) => {
      resolve(response);
    };

    const onError = (error) => {
      console.log("Error while adding the Product to the List", error);
      reject(error);
    };

    swat.addProductToLists(productObj, lists, onSuccess, onError);
  });
};

// Function to duplicate wishlist
export const duplicateWishlist = async (listName, fromListId) => {
  const swat = await swatPromise; // Wait for the promise to resolve

  const listConfig = {
    "lname": listName,
    "fromlid": fromListId
  };

  return new Promise((resolve, reject) => {
    const onSuccess = (newList) => {
      resolve(newList);
    };

    const onError = (error) => {
      console.log("Error while duplicating list", error);
      reject(error);
    };

    swat.createList(listConfig, onSuccess, onError);
  });
};

// Function to delete a product from multiple wishlist
export const deleteProductFromMultipleList = async (lists, product, variantDetails) => {
  const swat = await swatPromise; // Wait for the promise to resolve

  const productObj = {
    du: `${window.location.origin}/products/${product?.handle}`,
    empi: product?.id,
    epi: variantDetails?.selectedVariant?.id || null
  }
  
  return new Promise((resolve, reject) => {
    const onSuccess = (response) => {
      resolve(response);
    };

    const onError = (error) => {
      console.log("Error while deleting the Product from the List", error);
      reject(error);
    };

    swat.removeProductFromLists(productObj, lists, onSuccess, onError);
  });
};

// Function to delete a product from single wishlist
export const deleteProductFromList = async (listId, productLink, productId, variantId) => {
  const swat = await swatPromise; // Wait for the promise to resolve

  const productObj = {
    du: productLink,
    empi: productId,
    epi: variantId
  }
  
  return new Promise((resolve, reject) => {
    const onSuccess = (response) => {
      resolve(response);
    };

    const onError = (error) => {
      console.log("Error while deleting the Product from the List", error);
      reject(error);
    };

    swat.deleteFromList(listId, productObj, onSuccess, onError);
  });
};

// Function to get the shareable link
export const getSharedListURL = async (listId) => {
  const swat = await swatPromise; // Wait for the promise to resolve
  
  return new Promise((resolve, reject) => {
    const onSuccess = (response) => {
      resolve(response);
    };

    const onError = (error) => {
      console.log("Error while generating the link", error);
      reject(error);
    };

    swat.generateSharedListURL(listId, onSuccess, onError);
  });
};

// Function to send the list on email
export const sendListToEmail = async (listId, toEmail, fromEmail, message) => {
  const swat = await swatPromise; // Wait for the promise to resolve

  let params = {
    toEmailId: toEmail, // To Email
    fromName: fromEmail, // From Name 
    note: message,  // Note 
    lid: listId, // null when multiple list is not enabled
  }

  return new Promise((resolve, reject) => {
    const onSuccess = (response) => {
      resolve(response);
    };

    const onError = (error) => {
      console.log("There was an Error Sending the email", error);
      reject(error);
    };

    swat.sendListViaEmail(params, onSuccess, onError);
  });
};

// Function delete a wishlist
export const deleteWishlist = async (listId) => {
  const swat = await swatPromise; // Wait for the promise to resolve

  return new Promise((resolve, reject) => {
    const onSuccess = (response) => {
      resolve(response);
    };

    const onError = (error) => {
      console.log("Error while deleting a List", error);
      reject(error);
    };

    swat.deleteList(listId, onSuccess, onError);
  });
};
